import React from 'react';
import ContainerFormPublicar from './ContainerFormPublicar';
import ContainerFormCliente from './ContainerFormCliente';
import ContainerFormTurista from './ContainerFormTurista';
import ContainerFormPeriodista from './ContainerFormPeriodista';
import ContainerFormOtro from './ContainerFormOtro';
import { stringify } from 'rebem-classname';

export default function RenderContacto({ selectSoy, onChange, to, referencia, hacia, accion}){
	const block="contactoForm";
	const formPara = (soy) => {
		switch(soy){
			case 'dueño':
				return <ContainerFormPublicar 
							to={to['dueño']}
							onCloseModal={null}
							buttonClass=''
							precarga={null}
						/>;
			case 'cliente':
				return <ContainerFormCliente
					to={to['cliente']}
					referencia={referencia}
					hacia={hacia}
					accion={accion}
				/>;
			case 'turista':
				return <ContainerFormTurista to={to['turista']}/>;
			case 'periodista':
				return <ContainerFormPeriodista to={to['periodista']}/>;
			case 'otro':
				return <ContainerFormOtro to={to['otro']}/>;
			default: 
				return null;
		}
	};

	return (
		<div>
			<div className={`container ${stringify({block})}`}>
				<div className="row">
					<div className={`col-xs-12 ${stringify({block, elem:"titulo"})}`}>
						Tenemos nuestro equipo a tu disposición
					</div>
				</div>
				<div className="row">
					<div className={`col-xs-12 ${stringify({block,elem:"descripcion"})}`}>
						Formulario de Contacto con Alquiler Argentina
					</div>
				</div>
				<div className="row">
					<div className={`col-xs-12 col-md-6 ${stringify({block, elem:"imagen"})}`}>
						<div className={stringify({block, elem:"imagen-contacto"})}>
							<img src='https://cdn.econnectjapan.com/img/icon-customer-service.svg'/>
						</div>
					</div>
					<div className={`col-xs-12 col-md-6 ${stringify({block, elem:"form"})}`}>
						<div className={stringify({block, elem:"form-contacto"})}>
							<div className="container-fluid">
								<select value={selectSoy} onChange={onChange}>
									<option value="dueño">Soy: Dueño de un alojamiento a Publicar</option>
									<option value="cliente">Soy: Cliente o fui cliente de AlquilerArgentina.com</option>
									<option value="turista">Soy: Turista</option>
									<option value="periodista">Soy: Periodista</option>
									<option value="otro">Soy: Otro</option>
								</select>
							</div>
							{formPara(selectSoy)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}